/* TALO motion — machined reveals, header state, drag physics, parallax.
   No libraries. Damped, no bounce. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveals ---- */
  function arm() {
    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      if (!group.querySelector('[data-reveal]')) {
        Array.prototype.forEach.call(group.children, function (kid) {
          kid.setAttribute('data-reveal', '');
        });
      }
      var kids = group.querySelectorAll('[data-reveal]');
      var small = window.matchMedia('(max-width: 749px)').matches;
      kids.forEach(function (kid, i) {
        if (!kid.style.transitionDelay) kid.style.transitionDelay = Math.min(i * (small ? 40 : 60), small ? 120 : 240) + 'ms';
      });
    });
    var els = document.querySelectorAll('[data-reveal]:not(.rv-armed)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rv-armed', 'rv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('rv-in');
        io.unobserve(e.target);
      });
    }, window.matchMedia('(max-width: 749px)').matches
      ? { rootMargin: '0px 0px 4% 0px', threshold: 0.03 }   /* phones: settle in early, no blank-then-pop */
      : { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) {
      el.classList.add('rv-armed');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
  document.addEventListener('shopify:section:load', arm);

  /* ---- Product morph: tag clicked card image for the view transition ---- */
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest('a[href*="/products/"]');
    if (!link) return;
    var imgs = link.querySelectorAll('img');
    if (!imgs.length) return;
    var img = imgs[0];
    imgs.forEach(function (i) { if (getComputedStyle(i).opacity !== '0') img = i; });
    img.style.viewTransitionName = 'product-hero';
  }, true);

  /* ---- Header state: hysteresis, transform-only, no flap ---- */
  (function () {
    var body = document.body;
    var lastY = window.scrollY;
    var anchorY = lastY; /* where the current direction started */
    var dir = 0;
    var ticking = false;
    var TOP_ZONE = 90;
    var HIDE_AFTER = 110; /* committed downward travel before hiding */
    var SHOW_AFTER = 20;  /* upward travel before showing */
    var COOLDOWN = 260;   /* ms between state flips */
    var lastFlip = 0;
    function update() {
      var y = window.scrollY;
      var d = y > lastY ? 1 : (y < lastY ? -1 : dir);
      if (d !== dir) { dir = d; anchorY = lastY; }
      var travel = Math.abs(y - anchorY);
      var megaOpen = !!document.querySelector('.talo-nav-item.open');
      var now = performance.now();
      if (y < TOP_ZONE) {
        body.classList.remove('hdr-hidden', 'hdr-solid');
      } else if (megaOpen) {
        body.classList.remove('hdr-hidden');
        body.classList.add('hdr-solid');
      } else if (now - lastFlip > COOLDOWN) {
        if (dir === 1 && travel > HIDE_AFTER && !body.classList.contains('hdr-hidden')) {
          body.classList.add('hdr-hidden');
          body.classList.remove('hdr-solid');
          lastFlip = now;
        } else if (dir === -1 && travel > SHOW_AFTER && body.classList.contains('hdr-hidden')) {
          body.classList.remove('hdr-hidden');
          body.classList.add('hdr-solid');
          lastFlip = now;
        }
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  /* ---- Drag physics: grab, fling, snap for horizontal rails ---- */
  function makeDraggable(rail) {
    if (!rail || rail.dataset.dragArmed) return;
    rail.dataset.dragArmed = '1';
    rail.style.cursor = 'grab';
    var down = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, vel = 0, moved = false, raf = null;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; /* native touch scroll is already liquid */
      down = true; moved = false;
      startX = e.clientX; startLeft = rail.scrollLeft;
      lastX = e.clientX; lastT = performance.now(); vel = 0;
      rail.style.cursor = 'grabbing';
      rail.style.scrollBehavior = 'auto';
      rail.style.scrollSnapType = 'none';
      if (raf) cancelAnimationFrame(raf);
      /* NO pointer capture here: capturing retargets the click to the rail
         and card links never fire. Capture only once a real drag starts. */
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 12) {
        moved = true; /* forgiving: a jittery press is a click, not a drag */
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      }
      rail.scrollLeft = startLeft - dx;
      var now = performance.now();
      var dt = now - lastT;
      if (dt > 0) vel = (e.clientX - lastX) / dt;
      lastX = e.clientX; lastT = now;
    });
    function release() {
      if (!down) return;
      down = false;
      rail.style.cursor = 'grab';
      var v = vel * 14; /* fling momentum */
      function glide() {
        if (Math.abs(v) < 0.6) {
          rail.style.scrollSnapType = '';
          rail.style.scrollBehavior = '';
          return;
        }
        rail.scrollLeft -= v;
        v *= 0.94;
        raf = requestAnimationFrame(glide);
      }
      if (!reduced && Math.abs(v) > 1) { glide(); }
      else { rail.style.scrollSnapType = ''; rail.style.scrollBehavior = ''; }
      /* the swallow window closes right after the click event fires */
      setTimeout(function () { moved = false; }, 120);
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    /* swallow the click that follows a drag so cards don't navigate */
    rail.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  function armRails() {
    document.querySelectorAll('.talo-rail, [data-draggable]').forEach(makeDraggable);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armRails);
  } else {
    armRails();
  }
  document.addEventListener('shopify:section:load', armRails);

  /* ---- Parallax: exhibits drift a few px against scroll ---- */
  if (!reduced) {
    (function () {
      var els = null, ticking = false;
      function collect() { els = document.querySelectorAll('[data-parallax]'); }
      function step() {
        var vh = window.innerHeight;
        els.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var progress = (r.top + r.height / 2 - vh / 2) / vh; /* -0.5..0.5 */
          el.style.transform = 'translateY(' + (progress * -14).toFixed(1) + 'px)';
        });
        ticking = false;
      }
      collect();
      document.addEventListener('shopify:section:load', collect);
      window.addEventListener('scroll', function () {
        if (!ticking && els && els.length) { ticking = true; requestAnimationFrame(step); }
      }, { passive: true });
    })();
  }

  /* ---- Sticky buy bar: appears when the main buy button leaves view ---- */
  (function () {
    var bar = document.getElementById('talo-stickybuy');
    if (!bar) return;
    /* .talo-phero-actions is the homepage hero's buy block; the Dawn
       selectors cover the product page. Order matters: most specific first. */
    /* Dawn selectors cover the product page; .talo-hero-btn is the homepage
       hero CTA, so the bar appears once the hero scrolls past. */
    var anchor = document.querySelector('.product-form__submit')
      || document.querySelector('.product__info-wrapper .price')
      || document.querySelector('.talo-buy-actions')
      || document.querySelector('.talo-hero-btn');
    if (!anchor) return;
    if ('IntersectionObserver' in window) {
      /* Product page: the bar shows from arrival whenever the real buy button
         is off screen, above or below (owner, 2026-09-25, after Clarity showed
         half of phone visitors never scroll to the button). The price now sits
         above the bar's reach and the bar carries the shipping and returns
         promise. Other pages: it appears once the buy button has scrolled past. */
      var pdp = bar.classList.contains('talo-stickybuy--pdp');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = pdp ? !e.isIntersecting : (!e.isIntersecting && e.boundingClientRect.top < 0);
          bar.classList.toggle('on', past);
          bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(anchor);
    }
    var add = bar.querySelector('[data-sticky-add]');
    if (add) {
      add.addEventListener('click', function () {
        var real = document.querySelector('product-form form [type="submit"], form[action*="/cart/add"] [type="submit"]');
        if (real) real.click();
      });
    }
    /* smooth-scroll the join link to the on-page wall */
    var join = bar.querySelector('a[href="#talo-join"]');
    if (join) {
      join.addEventListener('click', function (e) {
        var target = document.querySelector('.talo-join') || document.getElementById('talo-join');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
      });
    }
  })();

  /* ---- Product gallery: first image hovers to the alternate angle ---- */
  (function () {
    function armGalleryHover() {
      var items = document.querySelectorAll('.product__media-list .product__media-item img');
      if (items.length < 2) return;
      var first = items[0];
      var wrap = first.closest('.product__media-item');
      if (!wrap || wrap.dataset.hoverArmed) return;
      wrap.dataset.hoverArmed = '1';
      var alt = document.createElement('img');
      alt.src = items[1].currentSrc || items[1].src;
      alt.alt = first.alt ? first.alt + ', alternate angle' : '';
      alt.className = 'talo-gallery-alt';
      var host = first.parentElement;
      host.style.position = 'relative';
      host.appendChild(alt);
      wrap.addEventListener('mouseenter', function () { alt.style.opacity = '1'; });
      wrap.addEventListener('mouseleave', function () { alt.style.opacity = '0'; });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', armGalleryHover);
    } else {
      armGalleryHover();
    }
    document.addEventListener('shopify:section:load', armGalleryHover);
  })();

  /* ---- Deep parallax: full-bleed section backgrounds drift against scroll ---- */
  if (!reduced) {
    (function () {
      var els = null, ticking = false;
      function collect() { els = document.querySelectorAll('.talo-fullband-img, .talo-join-bg'); }
      function step() {
        var vh = window.innerHeight;
        els.forEach(function (el) {
          var host = el.parentElement.getBoundingClientRect();
          if (host.bottom < -80 || host.top > vh + 80) return;
          var p = (host.top + host.height / 2 - vh / 2) / (vh + host.height);
          el.style.transform = 'translateY(' + (p * -90).toFixed(1) + 'px) scale(1.15)';
        });
        ticking = false;
      }
      collect();
      step();
      document.addEventListener('shopify:section:load', function () { collect(); step(); });
      window.addEventListener('scroll', function () {
        if (!ticking && els && els.length) { ticking = true; requestAnimationFrame(step); }
      }, { passive: true });
    })();
  }

  /* ---- Lightbox pinch zoom: two fingers scale the image, one finger pans, double-tap toggles ---- */
  (function () {
    var modal = document.querySelector('.product-media-modal__content');
    if (!modal) return;
    var img = null, scale = 1, tx = 0, ty = 0, startDist = 0, startScale = 1, lastTap = 0;
    var panStart = null, panOrigin = null;
    /* Anchor for the current pinch: the layout origin of the image and the
       point of the photo sitting under the two fingers when the gesture
       began. Without these, scaling with transform-origin 0 0 grows the image
       out of its top-left corner, so pinching anywhere zoomed the corner
       instead of whatever you pinched. */
    var pinchL = 0, pinchT = 0, pinchCX = 0, pinchCY = 0;
    function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }
    function active() { return modal.querySelector('.active img') || modal.querySelector('img'); }
    function apply() { if (img) img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    function reset() { scale = 1; tx = 0; ty = 0; if (img) { img.classList.remove('is-zooming'); apply(); } }
    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx*dx + dy*dy); }
    modal.addEventListener('touchstart', function (e) {
      img = active(); if (!img) return;
      if (e.touches.length === 2) {
        e.preventDefault();
        var r0 = img.getBoundingClientRect(), m0 = mid(e.touches);
        pinchL = r0.left - tx; pinchT = r0.top - ty;
        pinchCX = (m0.x - r0.left) / scale; pinchCY = (m0.y - r0.top) / scale;
        startDist = dist(e.touches); startScale = scale; img.classList.add('is-zooming');
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < 300) {
          e.preventDefault();
          if (scale > 1) { reset(); } else {
            var r = img.getBoundingClientRect();
            scale = 2.5; tx = -(e.touches[0].clientX - r.left) * (scale - 1); ty = -(e.touches[0].clientY - r.top) * (scale - 1); apply();
          }
        }
        lastTap = now;
        if (scale > 1) { panStart = { x: e.touches[0].clientX, y: e.touches[0].clientY }; panOrigin = { x: tx, y: ty }; }
      }
    }, { passive: false });
    modal.addEventListener('touchmove', function (e) {
      if (!img) return;
      if (e.touches.length === 2) {
        e.preventDefault();
        scale = Math.min(4, Math.max(1, startScale * dist(e.touches) / startDist));
        /* Keep the pinched point of the photo under the fingers */
        var m = mid(e.touches);
        tx = m.x - pinchL - pinchCX * scale;
        ty = m.y - pinchT - pinchCY * scale;
        apply();
      } else if (e.touches.length === 1 && scale > 1 && panStart) {
        e.preventDefault();
        tx = panOrigin.x + (e.touches[0].clientX - panStart.x); ty = panOrigin.y + (e.touches[0].clientY - panStart.y); apply();
      }
    }, { passive: false });
    modal.addEventListener('touchend', function (e) {
      if (e.touches.length < 2 && img) { img.classList.remove('is-zooming'); if (scale <= 1.02) reset(); }
      if (e.touches.length === 0) panStart = null;
    });
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('.product__modal-opener, .product-media-modal__toggle')) setTimeout(reset, 50);
    }, true);
  })();

  /* ---- Wishlist: localStorage, heart toggles, header count, drawer ---- */
  (function () {
    var KEY = 'talo-wish';
    function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    var drawer = document.getElementById('talo-wishd');
    function render() {
      var list = load();
      document.querySelectorAll('[data-wish]').forEach(function (b) {
        var on = list.some(function (i) { return i.handle === b.dataset.handle; });
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var t = b.querySelector('.talo-wish-txt'); if (t) t.textContent = on ? 'Saved' : 'Save';
      });
      var n = document.querySelector('.talo-wish-hdr-n'); if (n) n.textContent = list.length ? '(' + list.length + ')' : '';
      if (!drawer) return;
      var ul = drawer.querySelector('[data-wishd-list]'), empty = drawer.querySelector('[data-wishd-empty]');
      ul.innerHTML = list.map(function (i) {
        return '<div class="talo-wishd-item"><img src="' + i.img + '" alt=""><div><a class="talo-wishd-t" href="' + i.url + '">' + i.title + '</a><div class="talo-wishd-p">' + i.price + '</div></div><button type="button" class="talo-wishd-rm" data-wishd-rm="' + i.handle + '">Remove</button></div>';
      }).join('');
      empty.hidden = list.length > 0;
    }
    function open() { if (!drawer) return; render(); drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
    function close() { if (!drawer) return; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]');
      if (b) {
        var list = load(), idx = list.findIndex(function (i) { return i.handle === b.dataset.handle; });
        if (idx > -1) list.splice(idx, 1); else list.push({ handle: b.dataset.handle, title: b.dataset.title, price: b.dataset.price, url: b.dataset.url, img: b.dataset.img });
        save(list); render(); if (idx === -1) open(); return;
      }
      var rm = e.target.closest('[data-wishd-rm]');
      if (rm) { save(load().filter(function (i) { return i.handle !== rm.dataset.wishdRm; })); render(); return; }
      if (e.target.closest('[data-wishd-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-wishd-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    /* header entry point, before the cart link */
    var icons = document.querySelector('.header__icons');
    if (icons && !icons.querySelector('.talo-wish-hdr')) {
      var h = document.createElement('button'); h.type = 'button'; h.className = 'talo-wish-hdr'; h.setAttribute('data-wishd-open', ''); h.setAttribute('aria-label', 'Saved items');
      h.innerHTML = '<span class="talo-wish-ic" aria-hidden="true"></span><span>Saved</span> <span class="talo-wish-hdr-n"></span>';
      icons.insertBefore(h, icons.firstChild);
    }
    render();
  })();
})();

  /* ---- Gallery: fade the main photo when a thumbnail is picked ---- */
  (function () {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.thumbnail, .thumbnail-list__item button');
      if (!t) return;
      var items = list.querySelectorAll('.product__media-item');
      items.forEach(function (it) { it.classList.add('talo-fading'); });
      setTimeout(function () { items.forEach(function (it) { it.classList.remove('talo-fading'); }); }, 40);
    }, true);
  })();

